import { ThemeProvider } from "@emotion/react";
import { LocalizationProvider } from "@mui/lab";
import { CssBaseline } from "@mui/material";
import React from "react";
import Navbar from "./components/Navbar";
import LightTheme from './themes/LightTheme'
import AdapterMoment from '@mui/lab/AdapterMoment';
import NotificationContainer from "components/Notification";
import RoutesContainer from "components/Routes";
import AuthContextProvider from "components/providers/AuthCtx";

const App: React.FC = () => {
    return (
        <ThemeProvider theme={LightTheme}>
            <CssBaseline />
            <LocalizationProvider
                dateAdapter={AdapterMoment}
                adapterLocale="en"
                dateFormats={{
                    normalDate: 'YYYY-MM-DD',
                    keyboardDate: 'YYYY-MM-DD',
                }}>
                <NotificationContainer>
                    <AuthContextProvider>
                        <RoutesContainer>
                            <Navbar />
                        </RoutesContainer>
                    </AuthContextProvider>
                </NotificationContainer>
            </LocalizationProvider>
        </ThemeProvider>
    );
}

export default App;
